module.exports = __webpack_public_path__ + "img/2.a652a8ef.png";